import React from 'react';
import './shared.css';

const STATUS_CONFIG = {
  draft: { label: 'Draft', className: 'status-draft' },
  invited: { label: 'Invited', className: 'status-invited' },
  quoted: { label: 'Quoted', className: 'status-quoted' },
  approved: { label: 'Approved', className: 'status-approved' },
  active: { label: 'Active', className: 'status-active' },
  completed: { label: 'Completed', className: 'status-completed' },
  cancelled: { label: 'Cancelled', className: 'status-cancelled' },
  pending: { label: 'Pending', className: 'status-quoted' },
  declined: { label: 'Declined', className: 'status-cancelled' },
  checked_in: { label: 'On Site', className: 'status-active' },
  checked_out: { label: 'Left', className: 'status-draft' },
};

const StatusBadge = ({ status, size = 'normal' }) => {
  const config = STATUS_CONFIG[status] || { label: status, className: 'status-draft' };
  return (
    <span className={`cs-status-badge ${config.className} ${size === 'small' ? 'cs-status-sm' : ''}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
